import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, ref, computed, onMounted, watch, withDefaults, nextTick } from 'vue';
import type { Ref } from 'vue';
import { add, guessTimezone } from '@white-label-helper/date-utilities';
import { ControlButton, TextFieldDate, NumSelector, ModalCenter } from 'ui-shared-components';
import type { TimeslotFormData } from '@white-label-types/component';
import FlightSearchDropdown from '../flight-search-dropdown/flight-search-dropdown.vue';
import { FlightInfo } from '@white-label-types/search-box';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';


export default /*#__PURE__*/_defineComponent({
  __name: 'search-timeslot-edit-form',
  props: {
    timeZone: { default: guessTimezone() },
    formData: null,
    selectedFlight: null,
    flights: null,
    flightsRequestStatus: null,
    maxPassengers: { default: 6 },
    updatingSearch: { type: Boolean, default: false },
    apiRequestRunning: { type: Boolean, default: false },
    customErrorMessages: { default: () => ({}) },
    searchButtonText: { default: 'searchEditForm.button.update' },
    flightLabel: { default: 'Find my flight' },
    onDepartureDateChange: { type: Function, default: () => {} }
  },
  emits: [
  'flight-change',
  'departure-date-selected',
  'departure-date-change',
  'cancel-changes',
  'update-search',
  'update-desktop-bg',
],
  setup(__props: any, { emit }) {

const props = __props as { timeZone: string, formData: TimeslotFormData, selectedFlight: Object, flights: Array<object>, flightsRequestStatus: 'empty'|'loading'|'success'|'error', maxPassengers: number, updatingSearch: boolean, apiRequestRunning: boolean, customErrorMessages: object, searchButtonText: string, flightLabel: string, onDepartureDateChange: (payload: any) => void };

const IconButton = defineAsyncComponent(() => import('@white-label-icon/icon-button'));



const departureDate: Ref<string> = ref('');
const disableFlightSearch = computed(() => {
  return departureDate.value === "" || props.apiRequestRunning
});
const passengers: Ref<number> = ref(props.formData.passengers);
const modalOpen: Ref<boolean> = ref(false);
const rerenderKey = ref(0);

const controlDate = computed((): object => {
  return {
    timeZone: guessTimezone(),
    minDate: new Date(),
    maxDate: add(new Date(), { days: 14 }),
  }
});

const formHasChanges = computed((): boolean => {
  const isDepartureDateChanged = departureDate.value !== props.formData.departureDate;
  const isPassengersChanged = passengers.value !== props.formData.passengers;
  const isFlightChanged = props.selectedFlight.flightNumber && props.selectedFlight.flightNumber !== props.formData.flightNumber;
  const formHasChanged = (
    isDepartureDateChanged || isPassengersChanged || isFlightChanged
  );

  return (
    formHasChanged && (props.selectedFlight.flightNumber !== undefined)
  );
});

const prependIcon = computed(() => {
  return () => import('@white-label-icon/icon-calendar');
});

watch(() => props.formData, (newValue) => updateFields(), { deep: true });

watch(() => props.selectedFlight, async () => {
  rerenderKey.value += 1;
});

onMounted(() => {
  updateFields();
});




const onFlightChange = (flight: Ref<FlightInfo> | FlightInfo): void => emit('flight-change', flight);

const modalTrigger = (): boolean => modalOpen.value = true;

const closeModal = (): boolean => modalOpen.value = false;

const updateFields = (): void => {
  if (departureDate.value !== props.formData.departureDate) {
    onFlightChange({});
    emit('departure-date-change', props.formData);
    emit('departure-date-selected', props.formData);
  }

  departureDate.value = props.formData.departureDate || '';
};

const onCancelChanges = (): void => emit('cancel-changes');

const onSubmit = (): void => {
  const params = {
    departureDate: departureDate.value,
    flightNumber: props.selectedFlight.flightNumber === "" ? undefined : props.selectedFlight.flightNumber,
    passengers: passengers.value,
    productName: 'product',
    terminal: props.selectedFlight.terminal,
    airline: props.selectedFlight.airline,
    flightDepartureTime: props.selectedFlight.time,

  };
  localStorage.setItem('searchCriteriaSerialized', JSON.stringify(params));
  emit('update-search', params);

  updateDesktopBackdrop(false);
};

const updateDesktopBackdrop = (value: boolean): void => emit('update-desktop-bg', value);

const showTwoTerminalsInfo = getFeatureFlag('CRO_989_TIMESLOT_SHOW_TWO_TERMINALS_MESSAGE', false);

return { __sfc: true,IconButton, props, departureDate, disableFlightSearch, passengers, modalOpen, rerenderKey, controlDate, formHasChanges, prependIcon, emit, onFlightChange, modalTrigger, closeModal, updateFields, onCancelChanges, onSubmit, updateDesktopBackdrop, showTwoTerminalsInfo, ControlButton, TextFieldDate, NumSelector, ModalCenter, FlightSearchDropdown }
}

})